export default __webpack_public_path__ + "table-grid.png";